module.exports = __webpack_public_path__ + "static/media/asist.carretera.53e5d86d.png";